<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Criar Ticket</h1>

    <SGPModalComponent v-if="abrirModalDesignacao" tamanho="lg" titulo="Designação"
      @sgpModalFechar="fecharModalDesignacao" :mostrarFooter="false">
      <FormularioCtrlDesignacaoComponent :tipoFormulario="tipoFormularioDesignacao" :provedor="designacaoSelecionada"
        @designacaoSalva="onDesignacaoSalva" :exibirImportacao="false" />
    </SGPModalComponent>

    <FormularioTicketComponent ref="formTicket" :tipoFormulario="tipoFormulario" :ticket="ticket"
      @editarDesignacao="abrirModalEdicaoDesignacao" @criarDesignacao="abrirModalCriacaoDesignacao" />
  </div>
</template>

<script>
import moduleReload from '@/common/mixins/module-reload.js'
import FormularioTicketComponent from '../components/FormularioTicketComponent.vue'
import FormularioCtrlDesignacaoComponent from '../../ctrl-designacao/components/FormularioCtrlDesignacaoComponent.vue'

export default {
  name: 'TicketPage',
  mixins: [moduleReload],
  components: {
    FormularioTicketComponent,
    FormularioCtrlDesignacaoComponent,
  },

  data() {
    return {
      tipoFormulario: 'salvar',
      ticket: {},
      abrirModalDesignacao: false,
      designacaoSelecionada: {},
      tipoFormularioDesignacao: 'salvar',
    }
  },

  methods: {
    abrirModalEdicaoDesignacao(designacao) {
      this.tipoFormularioDesignacao = 'editar';
      this.designacaoSelecionada = designacao;
      this.abrirModalDesignacao = true;
    },

    abrirModalCriacaoDesignacao() {
      this.tipoFormularioDesignacao = 'salvar';
      this.designacaoSelecionada = {};
      this.abrirModalDesignacao = true;
    },

    fecharModalDesignacao() {
      this.abrirModalDesignacao = false;
      this.designacaoSelecionada = {};
      this.tipoFormularioDesignacao = 'salvar';
    },

    onDesignacaoSalva(designacaoSalva) {
      this.$refs.formTicket?.setDesignacaoSelecionada(designacaoSalva);
      this.fecharModalDesignacao();
    },
  },

  reloadData() {
    this.$router.push({ name: 'dashboard' });
  }
}
</script>
